import { React, useState, useEffect } from 'react'
import '../styles/pages/homepage.css'
import gold_loan from '../assets/images/goldloan.png'
import vehicle_loan from '../assets/images/vehicleloan.png'
import home_loan from '../assets/images/homeloan.png'
import business_loan from '../assets/images/business_loan.png'
import { Link } from 'react-router-dom'
import Button from '../components/Button.js'
import { MdOutlineDoubleArrow } from "react-icons/md";
import about_img from '../assets/images/about_img.png'
import { FaMapMarkerAlt } from "react-icons/fa";
import { RiDoubleQuotesL } from "react-icons/ri";
import about_us from '../assets/images/about_us.jpg';
import interest_rates from '../assets/images/interest_rates.webp';
import deposit from '../assets/images/deposits.webp'
import gallery from '../assets/images/gallery.png'
import Slider from '../components/Slider'
import SimpleCard from '../components/SimpleCard'
import Popup from 'reactjs-popup'
import Modal from '../components/Modal'
import ModalArray from '../components/ModalArray'
import ModelWelcome from '../components/ModelWelcome'
import { useAuth } from "../authentication/AuthContext";
import PopupModal from '../components/PopupModal.jsx'
import axios from "axios";
import { useLayoutEffect } from 'react'



function HomePage() {
    const { isAuthenticated } = useAuth();

    const image_list = [
        {
            text: "Gold Loan",
            img: gold_loan,
            link: ''
        },
        {
            text: "Vehicle Loan",
            img: vehicle_loan,
            link: ''
        },
        {
            text: "Home Loan",
            img: home_loan,
            link: ''
        },
        {
            text: "Business Loan",
            img: business_loan,
            link: ''
        }
    ];

    const [landingText, setLandingText] = useState("");
    const [welcomeText, setwelcomeText] = useState("");
    const [welcomeTextID, setwelcomeTextID] = useState("");
    const [news, setNews] = useState([]);
    const [open, setOpen] = useState(false);
    const [openImg, setOpenImg] = useState(false);

    const closeModal = () => setOpen(false);    
    const closeImgModal = () => setOpenImg(false);    
  
    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch("/api/homepage");
            const json = await response.json();
            if (response.ok) {
                setLandingText(json[0].content);
                setNews(json[1].news);
            }
        }
        fetchData();
        setTimeout(() => setOpen(true), 1000);
        setTimeout(() => setOpenImg(true), 2000);
    }, []);
    // fetching data for welcome section
    useEffect(() => {
        const fetchData = async () => {
            const resp = await fetch("/api/welcomePageController");
            const json = await resp.json();
           
            if (resp.ok) {
                setwelcomeText(json[0].para);
                setwelcomeTextID(json[0]._id)
            }
        }
        fetchData();
        setTimeout(() => setOpen(true), 1000);
        setTimeout(() => setOpenImg(true), 2000);
    }, []);

    const postLandingSectionData = async (e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget).get("landingSectionText");
        setLandingText(data);
        
        const response = await fetch("/api/landingsection", {
            method: "POST",
            body: JSON.stringify({
                label: "homepageText",
                content: data,
            }),
            headers: {
                "Content-type": "application/json"
            }
        });
    }

    const postWelcomsectionData = async (e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget).get("welcomeSectionData");
       setwelcomeText(data);
        
        const response = await fetch(`/api/welcomePageController/${welcomeTextID}`, {
            method: "PUT",
            body: JSON.stringify({
                label: "welcomepageText",
                para: data,
            }),
            headers: {
                "Content-type": "application/json"
            }
        });
    }

    const postNewsData = async (content) => {
        setNews(content);
        const response = await fetch("/api/news", {
            method: "POST",
            body: JSON.stringify({
                label: "news",
                news: content,
            }),
            headers: {
                "Content-type": "application/json"
            }
        });        
    }

  const [paragraph, setParagraph] = useState("");  // To store the paragraph text
  const [image, setImage] = useState(null);    
   useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get("/api/popup");
        

        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          const data = res.data[0];  // Access the first object in the array

         

          setParagraph(data.paragraph || "");  // Set the paragraph text

          // Set the image URL only if it exists and is valid
          if (data.imageUrl && data.imageUrl !== '') {
            setImage(`/api/popup/${data._id}`);  // Set image URL state
            setOpenImg(true);  // Open the image popup
          } else {
            setImage(null);  // Set to null if imageUrl is missing or empty
          }

          // Open the modals based on data availability
          if (data.paragraph) {
            setOpen(true);  // Open the paragraph popup if it exists
          }
        }
      } catch (err) {
        console.error("Error fetching content", err);
      }
    };

    fetchContent();
  }, []);

useEffect(() => {
  
}, [image]);
  
  
    return (

        <div className='container'>
          
     <div className="container">
      {image && paragraph ? (
        // Both image and paragraph exist, show both popups
        <>
          {/* Image Popup */}
          {('Rendering Image Popup:', openImg)} {/* Log openImg */}
           <Popup open={openImg} closeOnDocumentClick onClose={closeImgModal}>
  <div className="modal" style={{ backgroundColor: "transparent", padding: "20px", maxWidth: "90vw", maxHeight: "80vh", overflow: "hidden" }}>
    <a className="close" onClick={closeImgModal} style={{ fontSize: "16px", color: "black", position: "absolute", top: "10px", right: "20px", cursor: "pointer" }}>Close</a>
    <div className="content" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", overflow: "hidden" }}>
      <img
        src={image} // Use the image URL stored in state
        alt="Popup Image"
        style={{
          maxWidth: "100%",    
          maxHeight: "70vh",  
          objectFit: "contain", 
        }}
      />
    </div>
  </div>
</Popup>


          {/* Paragraph Popup */}
          {('Rendering Paragraph Popup:', open)} {/* Log open */}
          <Popup open={open} closeOnDocumentClick onClose={closeModal}>
            <div className="modal">
              <a className="close" onClick={closeModal} style={{ fontSize: "16px", color: "black", position: "absolute", top: "10px", right: "20px", cursor: "pointer" }}>Close</a>
              <div className="content">
                <p>{paragraph}</p>
              </div>
            </div>
          </Popup>
        </>
      ) : image ? (
        // Only image exists, show only image popup
        <>
          {('Rendering Only Image Popup:', openImg)} {/* Log openImg */}
           <Popup open={openImg} closeOnDocumentClick onClose={closeImgModal}>
  <div className="modal" style={{ backgroundColor: "transparent", padding: "20px", maxWidth: "90vw", maxHeight: "80vh", overflow: "hidden" }}>
    <a className="close" onClick={closeImgModal} style={{ fontSize: "16px", color: "black", position: "absolute", top: "10px", right: "20px", cursor: "pointer" }}>Close</a>
    <div className="content" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", overflow: "hidden" }}>
      <img
        src={image} // Use the image URL stored in state
        alt="Popup Image"
        style={{
          maxWidth: "100%",    
          maxHeight: "70vh",  
          objectFit: "contain", 
        }}
      />
    </div>
  </div>
</Popup>

        </>
      ) : paragraph ? (
        // Only paragraph exists, show only paragraph popup
        <>
          {('Rendering Paragraph Only Popup:', open)}
          <Popup open={open} closeOnDocumentClick onClose={closeModal}>
            <div className="modal">
              <a className="close" onClick={closeModal} style={{ height: "5px" }}>Close</a>
              <div className="content">
                <p>{paragraph}</p>
              </div>
            </div>
          </Popup>
        </>
      ) : null}
    </div>
              
            <section className='intro'>
                 
                <RiDoubleQuotesL />
                <div className='intro_grid'>
                    <div className='grid_two'> 
                    {isAuthenticated  && ( 
                        <PopupModal />
                        )}
                    {isAuthenticated  && (     
                                     
                        <Modal onSubmit={postLandingSectionData} 
                        value={landingText} 
                        label="landingSectionText"/>
                        
                    )}
                        <p className='headingText'>About Us:</p>
                        <p>{landingText}</p>
                    </div>
                    <div><Link to="/about"><img src={about_us} /><p className='subtext'>About Us</p></Link></div>
                    <div><Link to="/deposits/savings-account"><img src={deposit} /><p className='subtext'>Deposits</p></Link></div>
                    <div><Link to="/deposit-interest-rates"><img src={interest_rates} /><p className='subtext'>Interest Rates</p></Link></div>
                    <div><Link to="/gallery"><img src={gallery} /><p className='subtext' >Gallary</p></Link></div>
                </div>
            </section>

            <div className='break' />

            <section className='section news_container'>
                <p className='subtitle'>LATEST NEWS</p>
                {isAuthenticated  && (  
                <ModalArray onSubmit={postNewsData} 
                value={news} 
                label = "news"
                dbId="679651b2d6506f00d7e12c7c" 
                />
                )} 
                <div className='news'>
                    <div className='items'>
                        
                        {news.map((news) => {
                            return <div>
                            <MdOutlineDoubleArrow />
                            <span>{news}</span>
                        </div>
                        })}
                        
                        


                    </div>
                </div>
            </section>

            <div className='break' />

            <section className='section loans'>
                <p className='subtitle'>LOANS</p>
                <div>
                    <SimpleCard list={image_list} />
                </div>
                <Button text="View More" />
            </section>

            <div className='break' />
            <div className='break' />

            <section className='section'>
                <p className='subtitle'>FACILITIES</p>
                <div className='facilities'>
                    <Slider />
                </div>
            </section>


            <section className='about'>
            {isAuthenticated  && (
              <ModelWelcome onSubmit={postWelcomsectionData} 
              value={welcomeText} 
              label="welcomeSectionData"/>
             )} 
                <p className='subtitle hello'>WELCOME TO THE TALIKOTI SAHAKARI BANK NIYAMIT!</p>
                <p className='content' style={{whiteSpace:"pre-line"}}>
                    <img src={about_img} />
                    {welcomeText}
                    {/* Established on 28/03/1960 and licensed by Reserve Bank of India to carry on
                    banking business The Talikoti Sahakari Bank Niyamit, Talikoti is today reckoned as one of the
                    top-notch & leading amongst the Urban Co-operative banks operating in the region of North Karnataka.
                    In the six decades of its existence, the performance of bank has been prototypical in terms of
                    growth in deposits, advances & overall operational preeminent.
                    <br /> <br />
                    With a view to extend banking
                    services to the lower and middle class people of Talikoti and its surrounding villages, The Talikoti
                    Sahakari Bank is providing devised need based loan schemes, keeping in view every imaginable need of
                    an individual borrower and business holders. */}

                </p>

            </section>

            
              
            
            <div className='break' />

            <section className='section branches'>
                <FaMapMarkerAlt />
                <p>Want to visit us in person? <br /><span><Link to='/branches-and-bank-timings'>Check out all of our branches --{">"}</Link></span></p>
            </section>
            <div className='break' />
        </div>


    )
}

export default HomePage
